import { NoticeBoardCategoryService } from './../../../../shared/services/notice-board-category.service';
import { ToastrService } from 'ngx-toastr';
import { INoticeBoardCategory } from '../../../../_models/cms/INoticeBoard';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-notice-board-category-form',
  templateUrl: './notice-board-category-form.component.html'
})
export class NoticeBoardCategoryFormComponent implements OnInit {

  loading: boolean;
  title: string = 'Add Notice Board Category';
  noticeBoardCategory: INoticeBoardCategory;
  noticeBoardCategoryForm: FormGroup;
  id;

  constructor(private router: Router,
              private route: ActivatedRoute,
              private fb: FormBuilder,
              private toastrService: ToastrService,
              private service: NoticeBoardCategoryService) {
    this.id = this.route.snapshot.paramMap.get('id');
  }

  ngOnInit() {
    this.createNoticeBoardCategoryForm();
    if (this.id) this.service.get(this.id).subscribe((response: INoticeBoardCategory) => {
      if (response) {
        this.noticeBoardCategory = response;
        this.title = 'Edit Notice Board Category';
        this.setValueNoticeBoardCategoryForm();
      }
    });
  }

  createNoticeBoardCategoryForm() {
    this.noticeBoardCategoryForm = this.fb.group({
      id: ['0', Validators.required],
      name: ['', Validators.required],
      slug: ['', Validators.required],
    });
  }

  setValueNoticeBoardCategoryForm() {
    this.noticeBoardCategoryForm.patchValue({
      id: this.noticeBoardCategory.id,
      name: this.noticeBoardCategory.name,
      slug: this.noticeBoardCategory.slug,
    });
  }

  save() {
    if (this.noticeBoardCategoryForm.valid) {
      this.loading = true;
      this.noticeBoardCategory = Object.assign({}, this.noticeBoardCategoryForm.value);
      if (this.id) {
        this.service.update(this.id, this.noticeBoardCategory).subscribe(() => {
          this.toastrService.success('Notice Board Category updated successful');
          this.router.navigate(['/admin/notice-board-categories']);
        },
        (error) => console.log('HTTP Error', error),
        () => this.loading = false);
      }
      else {
        this.service.create(this.noticeBoardCategory).subscribe(() => {
          this.toastrService.success('Notice Board Category created successful');
          this.router.navigate(['/admin/notice-board-categories']);
        },
        (error) => console.log('HTTP Error', error),
        () => this.loading = false);
      }
    }
  }

  delete() {
    if (!confirm('Are you sure you want to delete this Notice Board Category?')) return;

    this.service.delete(this.id).subscribe(() => {
      this.toastrService.success('FAQ Category deleted successful');
      this.router.navigate(['/admin/notice-board-categories']);
    });
  }

}
